
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"10","height":"10","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M2.904 1.029a.312.312 0 01.442 0l3.75 3.75a.312.312 0 010 .442l-3.75 3.75a.312.312 0 11-.442-.442L6.434 5l-3.53-3.529a.312.312 0 010-.442z","fill":"#1A202C"}})])
          )
        }
      }
    